import "@fontsource/space-grotesk/300.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";

import { Theme, Direction, PaletteMode, ThemeOptions } from "@mui/material";
import {
  components,
  customShadows,
  darkPalette,
  lightPalette,
  typography,
} from "./common";
import { SizeRange, SpacingSizeRange } from "../types";
import { customSpacing } from "./common/spacing";

export const createThemeOptions = (
  mode: PaletteMode,
  direction?: Direction,
): ThemeOptions => {
  return {
    direction,
    palette: mode === "dark" ? darkPalette : lightPalette,
    typography,
    components,
    customShadows,
    customSpacing,
  };
};

declare module "@mui/material" {
  interface Theme {
    customShadows: SizeRange;
    customSpacing: SpacingSizeRange;
  }
  interface ThemeOptions {
    customShadows: SizeRange;
    customSpacing: SpacingSizeRange;
  }
}
